import type { ApiResponseBody, ApiSearchQuery } from '@/lib/api/api-type-helper';

// ---------------------------------------------------------------------------
// List API Types
// ---------------------------------------------------------------------------

export type GetTestAssetListQuery = ApiSearchQuery<'/v2/qa-force/test-assets', 'get'>;
export type GetTestAssetListResponse = ApiResponseBody<'/v2/qa-force/test-assets', 'get'>;
export type TestAssetListItem = GetTestAssetListResponse['items'][0];

// ---------------------------------------------------------------------------
// CSV Export API Types（簡易エクスポート: 一覧表示列を view モードで出力）
// ---------------------------------------------------------------------------

/** 簡易エクスポートのフィルタ。一覧 API と同じ絞り込みを使う（mode/encoding は固定注入）。 */
export type GetTestAssetsCsvFilters = GetTestAssetListQuery;
export type GetTestAssetsCsvResponse = ApiResponseBody<'/v2/qa-force/test-assets/csv', 'get'>;

// ---------------------------------------------------------------------------
// Count API Types
// ---------------------------------------------------------------------------

export type GetTestAssetCountQuery = ApiSearchQuery<'/v2/qa-force/test-assets/count', 'get'>;
export type GetTestAssetCountResponse = ApiResponseBody<'/v2/qa-force/test-assets/count', 'get'>;

// ---------------------------------------------------------------------------
// Domain enums
// ---------------------------------------------------------------------------

export const TestAssetStatus = {
  ACTIVE: 'ACTIVE',
  IN_MAINTENANCE: 'IN_MAINTENANCE',
  LEGACY: 'LEGACY'
} as const;
export type TestAssetStatus = (typeof TestAssetStatus)[keyof typeof TestAssetStatus];
const TEST_ASSET_STATUS_VALUES: ReadonlySet<string> = new Set(Object.values(TestAssetStatus));
export function isTestAssetStatus(value: string | null | undefined): value is TestAssetStatus {
  return value != null && TEST_ASSET_STATUS_VALUES.has(value);
}
export type TestAssetStatusFilter = TestAssetStatus | 'ALL';